// @flow
const types = {
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP',
  SIGN_OUT: 'SIGN_OUT',
  RESET_PASSWORD: 'RESET_PASSWORD',
  RECOVER_PASSWORD: 'RECOVER_PASSWORD',
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',

  SET_TABLE: 'SET_TABLE',
  SET_SITUATION: 'SET_SITUATION',
  SET_CARD_GAME: 'SET_CARD_GAME',
  SET_FIRST_PAIR: 'SET_FIRST_PAIR',
  SET_SECOND_PAIR: 'SET_SECOND_PAIR',

  SET_TABLE_2: 'SET_TABLE_2',
  SET_SITUATION_2: 'SET_SITUATION_2',
  SET_CARD_GAME_2: 'SET_CARD_GAME_2',
  SET_FIRST_PAIR_2: 'SET_FIRST_PAIR_2',
  SET_SECOND_PAIR_2: 'SET_SECOND_PAIR_2',

  SET_CURRENT_GAME_REF: 'SET_CURRENT_GAME_REF',

  GET_PROFILE_INFO: 'GET_PROFILE_INFO',
  CANCEL_SUB: 'CANCEL_SUB',
  REACTIVATE_SUB: 'REACTIVATE_SUB',

  GET_OPEN_STATS: 'GET_OPEN_STATS',
  GET_SIMILAR: 'GET_SIMILAR',
  UPGRADE_COST: 'UPGRADE_COST',
  UPGRADE: 'UPGRADE',

  GET_RESULTS: 'GET_RESULTS',
  GET_MISTAKES: 'GET_MISTAKES',

  GET_REF_SETTINGS: 'GET_REF_SETTINGS',
  GET_REF_PAYMENTS: 'GET_REF_PAYMENTS',
  GET_REF_USERS: 'GET_REF_USERS',
  POST_WITHDRAW: 'POST_WITHDRAW',
  SET_POSTFLOP_SIMILAR: 'SET_POSTFLOP_SIMILAR',
  SET_POSTFLOP_SITUATION: 'SET_POSTFLOP_SITUATION',
  GET_COMBO: 'GET_COMBO',
  GET_NEXT_COMBO: 'GET_NEXT_COMBO',
  GET_POSTFLOP_RESULTS_STAT: 'GET_POSTFLOP_RESULTS_STAT',
};

export default types;
